<template>
  <div class="onboarding-form-field">
    <div class="onboarding-field-label-row">
      <label
        class="text-body-2 font-weight-medium"
        :class="icon ? 'd-flex align-center ga-2' : 'd-block'"
      >
        <v-icon
          v-if="icon"
          size="16"
          color="primary"
        >
          {{ icon }}
        </v-icon>
        {{ label }}
      </label>
      <div class="onboarding-field-badge-slot">
        <AiBadge
          v-if="captured"
          :label="$t('onboarding.wizard.data-entry.ai-captured')"
        />
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import AiBadge from '../../AiBadge.vue'
import { useOnboardingDataEntryContext } from '../../composables/onboardingDataEntryContext'

const props = defineProps<{
  fieldKey: string
  label: string
  icon?: string
}>()

const { aiCapturedFields } = useOnboardingDataEntryContext()
const captured = computed(() => aiCapturedFields.value.has(props.fieldKey))
</script>

<style scoped>
/* Reserve space for optional “AI captured” badge so paired columns (e.g. city / zip) stay aligned */
.onboarding-field-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.onboarding-field-badge-slot {
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
}
</style>
